function createTitleInArr(arrays) {
  return arrays.map(obj => {
    const title = `${obj.title} (id ${obj.id})`;
    return { ...obj, title };
  });
};

export default createTitleInArr



// WEBPACK FOOTER //
// ./app/javascript/app/components/story_level_value/tableConfig.js